// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body .v-stepper__wrapper {\n  height: 100% !important;\n}\nbody .btnCanvas {\n  min-width: 20px;\n  width: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
